import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { CommonapiService } from '../../../Service/Commonapi.service';
import { PlanCalendarService } from 'src/app/Module/Core/PlanCalendar/PlanCalendar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-CTPlanReason',
  templateUrl: './CTPlanReason.component.html'
})
export class CTPlanReasonComponent implements OnInit {
  @Input() state: any; @Output() CallParent: EventEmitter<any> = new EventEmitter();
  reasonList = [];@Input() data: any;
  todayDate: any = new Date();
  constructor(private Winfoapi: CommonapiService, private planCalendarapi: PlanCalendarService) { }


  ngOnInit() {
  }
  show = false;
  Show(state) {
    this.state = state;
    this.state.reason.iserr = false;
    this.state.reason.err_txt = "";
    this.state.reason.value = "0";
    this.state.reasonComments.value = "";
    this.show = true;
  }
  planReasonCancel() {
    this.state.reasonComments.iserr = false;
    this.state.reasonComments.err_txt = "";
    this.Callparentfunc(0)
    this.show = false;
    
  }
  Callparentfunc(status,data=''){
    this.CallParent.emit({status:status,data:data});
  }
  resonCheck()
  {
    if (this.state.reasonComments.value != '')
    {
      this.state.reasonComments.iserr = false;
      this.state.reasonComments.err_txt = "";
    }
  }

  drpreason_Click() {
    if (this.state.reason.value == '' || this.state.reason.value == '0') {
      //this.state.reason.iserr = true; 
      //this.state.reason.err_txt = "Select reason";

    }
    else {
      this.state.reason.iserr = false;
      this.state.reason.err_txt = "";
    }


    this.state.reasonComments.iserr = false;
    this.state.reasonComments.err_txt = "";

  }
  async planDeleteReasonYes() {
    let isvalid = true;

    if ((this.state.reason.value) == "0") {

      this.state.reason.iserr = true;
      this.state.reason.err_txt = "Enter reason";
      isvalid = false;

    } else if ((this.state.reason.value) != "0") {
      this.state.reason.iserr = false;
      this.state.reason.err_txt = "";
    }

    let otherDeleteReasonID = '-1';
    this.reasonList.map((x, index) => {

      if (x.reason == 'Other' || x.reason == 'other') {
        otherDeleteReasonID = x.reason_id;

      }
    })

    if ((this.state.reason.value == otherDeleteReasonID) && this.state.reasonComments.value == '') {
      this.state.reasonComments.iserr = true;
      this.state.reasonComments.err_txt = "Enter reason comment";
      isvalid = false;
    }
    else {
      this.state.reasonComments.iserr = false;
      this.state.reasonComments.err_txt = "";
    }

    //isvalid = false;
    if (isvalid) {
      //$('#divPlanReasonCalendarPopup').removeClass('pop_active_card');


      console.log('selected obj', this.data);

      const format1 = "YYYY-MM-DD";
      let calenderDate = moment(this.data.calendar_date).format(format1)

      let currentDate = new Date();
      const currentDateFormat1 = "YYYY-MM-DD";//"DD MMMM YYYY";
      var formattedCurrentDate = moment(currentDate).format(currentDateFormat1);
      var title = "\"" + this.data.customer_name + "\"" + " plan has been removed by User";
      var postdata = {
        "planId": this.data.plan_id,
        "calendarDate": calenderDate,
        "customerId": this.data.customer_id,
        "movedToDate": "",
        "planAlongStatusSub": "3",
        "reasonId": this.state.reason.value,
        "reason": this.state.reasonComments.value,
        "title": title,
        "data": "",
        "isRead": "",
        "url": environment.angularurl + "#/user/planlist",
        "create_user": this.data.is_create_user,
        "presentMonth": this.data.presentMonth,
        "presentYear": this.data.presentYear,
        "preNextFlag": this.data.preNextFlag,
        "latitude": this.data.mainlatitude+"",
        "longitude": this.data.mainlongitude+"",  
        "startDate": this.data.startDate,   
      }
      console.log("postdata", postdata);
      //return false;
       this.planCalendarapi.api.loader.startLoading();
      this.planCalendarapi.PlanListEventGetUpdateV1(postdata, false).then(data => {
        if (data && data != undefined && data != '[]') {
          console.log('PlanListEventGetUpdateV1',data);
          if (data.planEventUpdateResponse.plan_id > 0) {
            this.state.reasonComments.iserr = false;
            this.state.reasonComments.err_txt = "";            
            this.show = false;
            // this.Callparentfunc(1,data.planListViewResponse[0]) //this is not old code
            this.Callparentfunc(1,data);
            
            //this.Winfoapi.loader.stopLoading();
            // this.loopcount = 0;
            // this.state.location = ""; // each time location will be set in state to aviod mismatch lat long
            // this.getLocation();
            // this.Check();

          }

        }

        this.planCalendarapi.api.loader.stopLoading();
      })



    }
  }
}
